import { Component, ElementRef, OnInit } from '@angular/core';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { Router } from '@angular/router';
import { MobileEcatalogService } from "../mobile-ecatalog.service"
interface SearchResultItem {
  carId: number; 
  carName: string;
  levelIds: string;
  linkageTargetType: string;
  manuId: string;
  modelId: string;
  subLinkageTargetType: string;
  vehicleTypeDescription: string;
}

@Component({
  selector: 'app-mobile-vin-search',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class ProductVinSearchComponent implements OnInit {

  isSearchSuccess: boolean = false;
  vinSearchValue: string = '';
  vinSearchResults: any[] = [];
  storageVinList: any[] = [];

  constructor(
    private ecatalogService: EcatalogService,
    public router: Router, 
    private mobileProductService: MobileEcatalogService
  ) { 
    
  }

  ngOnInit(): void {
    const storageVins = localStorage.getItem('mobileVinSearch');
    this.storageVinList = storageVins ? JSON.parse(storageVins) : [];
  }
  ngOnDestroy() {
    
  }
  clearVehiclesVin(){
    this.isSearchSuccess = false;
    this.vinSearchResults = [];
    this.vinSearchValue = "";
  }
  queryVehiclesByVin():void {
    let params = {
      "maxVehiclesToReturn": -1,
      "vin": this.vinSearchValue
    };
    this.ecatalogService.queryVehiclesByVin(params).subscribe(res=>{
      this.storageVinList = [...new Set([...this.storageVinList, this.vinSearchValue].filter(i=> (!!i)))]
      localStorage.setItem('mobileVinSearch', JSON.stringify(this.storageVinList))
      // search result
      this.vinSearchResults = [];
      this.vinSearchValue = "";
      this.isSearchSuccess = true;
      if(res?.rtnData?.length > 0){
        if(res?.rtnData?.length === 1){
          // if the result just includes one row, redirect to category
          this.handleChooseResult(res?.rtnData)
          return
        }
        this.vinSearchResults = res?.rtnData?.map((item: any)=> ({ ...item, checked: false }))
      }
    })
  }

  handleClearSearchStorage(){
    localStorage.removeItem('mobileVinSearch');
    this.storageVinList = [];
  }

  // select result 
  handleChooseResult(list: SearchResultItem[]){
    const vehicleList = list?.map(item=>{
      const { carId, linkageTargetType, levelIds, carName } = item;
      return { carId, linkageTargetType, levelIds, carName, checked: true }
    })
    const country = localStorage.getItem("country");
    this.mobileProductService.sendVehicleParams({
      vehicle: vehicleList,
      isMobile: true,
      type: 'vin',
      vin: this.vinSearchValue,
      tabIndex: 0
    })
    this.router.navigate(
      [`${country}/ecatalog`],
    );
  }
  // select storage item
  handleChooseStorage(vin: string){
    this.vinSearchValue = vin;
    this.queryVehiclesByVin();
  }

  handleSubmitNext(){
    const vehicleList = this.vinSearchResults?.filter((item: any)=> item.checked)
    this.handleChooseResult(vehicleList)
  }
}
